         <template>
  <div class="order_detail_page">
    <div class="time_line_box">
      <div
        class="time_line_item"
        v-for="(item, index) in orderStatusList"
        :key="index"
      >
        <div :class="['line_box', item.createTime ? 'active' : '']">
          <div class="line_pointer"></div>
        </div>
        <div :class="['name', item.createTime ? 'active_name' : '']">
          {{ item.orderStatusDesc }}
        </div>
        <div class="time" v-if="item.createTime">
          {{ item.createTime }}
        </div>
        <div v-else style="height: 30px"></div>
      </div>
    </div>
    <div class="order_detail_content">
      <el-form label-width="100px">
        <el-form-item label="订单编号">
          <span> {{ orderInfo.orderNo }}</span>
        </el-form-item>
        <el-form-item label="产品名称">
          <span> {{ orderInfo.productName }}</span>
        </el-form-item>
        <!-- <el-form-item label="大板编号">
          <span> {{}}</span>
        </el-form-item> -->
        <el-form-item label="审稿备注">
          <span> {{ orderInfo.reviewRemark }}</span>
        </el-form-item>
        <el-form-item label="支付方式">
          <span>
            {{ $enums.payTypeEnum.getLabelByValue(orderInfo.payType) }}</span
          >
        </el-form-item>
        <el-form-item label="下单时间">
          <span> {{ orderInfo.createTime }}</span>
        </el-form-item>
        <el-form-item label="印品参数">
          <div class="flex_wrap">
            <div style="width: 250px" class="mr12">
              材料名称:{{ orderInfo.categoryName }}
            </div>
            <div style="width: 250px" class="mr12">
              成品尺寸:
              {{ orderInfo.paperSizeHeight }}*{{ orderInfo.paperSizeWeight }}mm
            </div>
            <div style="width: 250px" class="mr12">
              印刷数量：{{ orderInfo.orderNum }}
            </div>
            <div style="width: 250px" class="mr12">
              覆膜：{{ orderInfo.tectorial }}
            </div>

            <div style="width: 250px" class="mr12">
              出货排列：{{ orderInfo.shipmentArrangement }}
            </div>
            <div
              style="width: 250px"
              class="mr12"
              v-if="orderInfo.shipmentArrangement === '单款拼大张'"
            >
              长边：{{ orderInfo.shipmentArrangementLongSide }}个 宽边：{{
                orderInfo.shipmentArrangementShortSide
              }}
            </div>
            <div style="width: 250px" class="mr12">
              模切类型：{{ orderInfo.cutType }}
            </div>
            <div style="width: 250px" class="mr12">
              产品类型：{{ orderInfo.productType }}
            </div>
            <br />
            <div class="mr12" style="width: 100%">
              后道工序：{{ orderInfo.categoryName }}-{{
                orderInfo.paperSizeHeight
              }}mm*{{ orderInfo.paperSizeWeight }}mm -{{ orderInfo.tectorial }}-
              <span v-if="orderInfo.cutType">
                模切{{ orderInfo.cutType }}-
              </span>
              <span v-if="orderInfo.moldingProcess">
                模切{{ orderInfo.moldingProcess
                }}{{ orderInfo.moldingProcessDieType }}-
              </span>
              <span v-if="orderInfo.productMode">
                {{ orderInfo.productMode }}-
              </span>
              <span v-if="specialProcess.length > 0">
                <span v-for="(item, index) of specialProcess" :key="index">
                  <span v-if="item === '烫金'">
                    {{ item }}[{{ orderInfo.specialProcessBronzingLong }}x{{
                      orderInfo.specialProcessBronzingShort
                    }}] {{ orderInfo.specialProcessBronzing }}-
                  </span>
                  <span v-else-if="item === '局部UV'">
                    {{ item }}[{{ orderInfo.specialProcessUvLong }}x{{
                      orderInfo.specialProcessUvShort
                    }}]-
                  </span>
                  <span v-else> {{ item }}- </span>
                </span>
              </span>

              <span v-if="orderInfo.packageCorediameter">
                卷芯直径{{ orderInfo.packageCorediameter }}-
              </span>
              <span v-if="orderInfo.packageMarkingDirection">
                {{ orderInfo.packageMarkingDirection }}-
              </span>
              <span v-if="orderInfo.packageMarkingWeight">
                {{ orderInfo.packageMarkingWeight }}-
              </span>
              <span v-if="orderInfo.packageMarkingWeightPaper">
                每卷{{ orderInfo.packageMarkingWeightPaper }}张-
              </span>
              <span v-if="orderInfo.packageMarkingWeightLength">
                每卷{{ orderInfo.packageMarkingWeightLength }}米-
              </span>
              <span v-if="orderInfo.packageMarkingWeightLength">
                每卷{{ orderInfo.packageMarkingWeightLength }}米-
              </span>
              <span v-if="orderInfo.packageMarkingWeightLength">
                每卷{{ orderInfo.packageMarkingWeightLength }}米-
              </span>
              <span v-if="orderInfo.printingSurface">
                印面:{{ orderInfo.printingSurface }}-
              </span>
              <span v-if="orderInfo.moldingType">
                成型类型:{{ orderInfo.moldingType }}-
              </span>
              <span v-if="orderInfo.packageType">
                {{ orderInfo.packageType }}-
              </span>
              <span> 印刷款数：{{ orderInfo.printNum }}; </span>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="文  件">
          <span> {{ orderInfo.fileName }}</span>
        </el-form-item>
        <el-form-item label="授权书">
          <div
            v-if="orderInfo.authenticationFileSuffix1 === 'pdf'"
            class="download"
            @click="toDownload(orderInfo.authenticationUrl1, '授权书')"
          >
            {{ $getFileNameByUrl(orderInfo.authenticationUrl1) }}
          </div>
          <div v-else>
            <el-image
              v-if="orderInfo.authenticationUrl1"
              style="width: 100px; height: 100px"
              :src="orderInfo.authenticationUrl1"
              :preview-src-list="[orderInfo.authenticationUrl1]"
            />
            <span v-else>-</span>
          </div>
        </el-form-item>
        <el-form-item label="委印许可">
          <div
            v-if="orderInfo.authenticationFileSuffix2 === 'pdf'"
            class="download"
            @click="toDownload(orderInfo.authenticationUrl2, '委印许可')"
          >
            {{ $getFileNameByUrl(orderInfo.authenticationUrl2) }}
          </div>
          <div v-else>
            <el-image
              v-if="orderInfo.authenticationUrl2"
              style="width: 100px; height: 100px"
              :src="orderInfo.authenticationUrl2"
              :preview-src-list="[orderInfo.authenticationUrl2]"
            />
            <span v-else>-</span>
          </div>
        </el-form-item>
        <el-form-item label="订单备注">
          <span>
            {{ orderInfo.reviewRemark ? orderInfo.reviewRemark : "-" }}</span
          >
        </el-form-item>
        <el-form-item label="收件信息">
          <span>
            {{ orderInfo.province }} {{ orderInfo.city }} {{ orderInfo.area
            }}{{ orderInfo.street }}{{ orderInfo.address }}</span
          >
          <span class="ml12"
            >{{ orderInfo.contactName }}:{{ orderInfo.phone }}</span
          >
        </el-form-item>
        <el-form-item label="订单价格">
          <span> ￥{{ orderInfo.orderPrice }}</span>
          <span v-if="orderInfo.discountPrice"
            >（折扣金额：{{ orderInfo.discountPrice }}）</span
          >
        </el-form-item>
        <el-form-item label="快递编号">
          <span>
            {{ orderInfo.tradeOrderNo ? orderInfo.tradeOrderNo : "-" }}</span
          >
        </el-form-item>
        <el-form-item label="物流信息" v-if="logisticsList.length > 0">
          <div>
            <el-timeline :reverse="false" class="mt12">
              <el-timeline-item
                v-for="(item, index) in logisticsList"
                :key="index"
                :timestamp="item.time"
              >
                {{ item.context }}
              </el-timeline-item>
            </el-timeline>
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { orderDetailApi, logisticsListApi } from "../../api/index";
export default {
  data() {
    return {
      orderId: 0,
      orderStatusList: [
        {
          orderStatusDesc: "创建订单",
          createTime: "",
        },
        {
          orderStatusDesc: "已审核",
          createTime: "",
        },
        {
          orderStatusDesc: "生产中",
          createTime: "",
        },
        {
          orderStatusDesc: "包装",
          createTime: "",
        },
        {
          orderStatusDesc: "配送中",
          createTime: "",
        },
        {
          orderStatusDesc: "已送达",
          createTime: "",
        },
      ],
      defaultList: ["创建订单", "已审核", "生产中", "包装", "配送中", "已送达"],
      orderInfo: {
        orderId: 1,
        orderNo: "32503128467",
        createTime: "2025-03-12 17:49:09",
        productName:
          "82001-YY轮毂轴承-条码1740-83x41mm--3000张-强粘83X41啤{随文件}-3000张不1M--不覆膜(32503044229).cdr",
        fileName: "文件名称",
        authenticationFileSuffix1: "png",
        authenticationUrl1: "",
        authenticationFileSuffix2: "png",
        authenticationUrl2: "",
        orderPrice: 10.11,
        freightPrice: 11.11,
        weight: 1,
        payType: "ONLINE",
        orderStatus: "UNPAY",
        verifyStatus: "VERIFYING",
        province: "山西省",
        reviewRemark: "审稿备注",
        tradeOrderNo: "1212",
        expressName: "平安达",
        city: "",
        area: "",
        street: "",
        address: "address",
        phone: "",
        contactName: "联系人名称",
        categoryName: "", //材料名称
        paperSizeWeight: 1, //成品尺寸 宽
        paperSizeHeight: 2, //成品尺寸 长  前端显示 长*宽
        shipmentArrangement: "", //出货排列  多个;隔开  任意、单个出货、单款拼大张
        shipmentArrangementShortSide: "", //单款拼大张 短边个数
        shipmentArrangementLongSide: "", //单款拼大张 长边个数
        cutType: "", //模切类型
        tectorial: "", //覆膜
        orderNum: 111, //印刷数量
        printNum: 11, //印刷款数
        productMode: "切成品", //成品模式 --专版不干胶
        specialProcess: "啤全穿", //特殊工艺多个;隔开 --专版不干胶
        specialProcessUvLong: "11", //局部UV 长边UV宽度 --专版不干胶
        specialProcessUvShort: "22", //局部UV 短边UV高度 --专版不干胶
        specialProcessBronzing: "黑金", //烫金类型 --专版不干胶
        specialProcessBronzingLong: "11", //长边烫工宽度   --专版不干胶
        specialProcessBronzingShort: "22", //短边烫工高度 --专版不干胶
        moldingProcess: "模切", //成型工艺--卷装标签、特殊卷标
        moldingProcessDieType: "圆形", //成型工艺 --卷装标签、特殊卷标
        packageCorediameter: "75mm", //包装方式 卷芯直径 --卷装标签、特殊卷标
        packageMarkingDirection: "上出标", //包装方式 出标方向 --卷装标签、特殊卷标
        packageMarkingWeight: "长边出标", //包装方式 出标宽度 --卷装标签、特殊卷标
        packageMarkingWeightPaper: "1000", //包装方式 每卷张数 单位张/卷 --卷装标签、特殊卷标
        packageMarkingWeightLength: "11", //包装方式 每卷长度 单位米/卷 --卷装标签、特殊卷标
        printingSurface: "彩色单面", //印  面--数码不干胶
        moldingType: "切成品", //成型类型--数码不干胶
        packageType: "标准包", //包装方式--数码不干胶
      },
      specialProcess: [],
      logisticsList: [],
    };
  },
  created() {
    this.orderId = this.$route.query.orderId || 0;
    this.getDetail();
  },
  activated() {
    this.orderId = this.$route.query.orderId || 0;
    this.getDetail();
  },
  methods: {
    getDetail() {
      if (this.orderId) {
        orderDetailApi({
          orderId: this.orderId,
        })
          .then((res) => {
            if (res.resultStatus) {
              this.orderStatusList = this.defaultList.map((f) => {
                const result =
                  res.resultData.orderStatusList.filter(
                    (order) => order.orderStatusDesc === f
                  ).length === 1
                    ? res.resultData.orderStatusList.filter(
                        (order) => order.orderStatusDesc === f
                      )[0]
                    : {};
                const obj = {
                  orderStatusDesc: f,
                  ...result,
                };
                return obj;
              });

              // res.resultData.orderStatusList || [];
              this.orderInfo = res.resultData.order;
              if (this.orderInfo.specialProcess) {
                this.specialProcess = this.orderInfo.specialProcess.split(";");
              }
            } else {
              this.orderStatusList = [];
              this.orderInfo = {};
            }
          })
          .finally(() => {
            // if (this.orderInfo.tradeOrderNo) {
            this.getLogisticsList();
            // }
          });
      }
    },
    toDownload(url, name) {
      this.$downLoadPDF(url, name);
    },
    getLogisticsList() {
      // const result =
      //   '{"message":"ok","nu":"78487667190486","ischeck":"1","condition":"F00","com":"zhongtong","status":"200","state":"3","data":[{"time":"2025-03-07 18:25:08","ftime":"2025-03-07 18:25:08","context":"【太原市】 您的快递已签收，签收人在【太原市融创外滩公馆12号楼店】取件。如有疑问请联系业务员：17635369936，代理点电话：13111118704，投诉电话：15534484441,15034011775。感谢使用中通快递，期待再次为您服务！"},{"time":"2025-03-07 17:45:22","ftime":"2025-03-07 17:45:22","context":"【太原市】 快件已被 菜鸟 的【太原市融创外滩公馆12号楼店】代收，【取件地址：和平北路融创外滩公馆12号楼底商微利便利店内】，请及时取件。代理点电话：13111118704，投诉电话：15534484441,15034011775"},{"time":"2025-03-07 14:46:33","ftime":"2025-03-07 14:46:33","context":"【太原市】太原柴村 的业务员【高龙,17635369936】正在为您派件（95720为中通快递员外呼专属号码，请放心接听，如有问题可联系网点:0351-2918368,投诉电话:15534484441,15034011775）"},{"time":"2025-03-07 14:44:53","ftime":"2025-03-07 14:44:53","context":"【太原市】 快件已到达 太原柴村"},{"time":"2025-03-07 09:09:34","ftime":"2025-03-07 09:09:34","context":"【晋中市】 快件已发往 太原柴村"},{"time":"2025-03-07 08:32:20","ftime":"2025-03-07 08:32:20","context":"【晋中市】 快件已到达 太原转运中心"},{"time":"2025-03-06 02:20:51","ftime":"2025-03-06 02:20:51","context":"【揭阳市】 快件已发往 太原转运中心"},{"time":"2025-03-06 02:16:05","ftime":"2025-03-06 02:16:05","context":"【揭阳市】 快件已到达 揭阳转运中心"},{"time":"2025-03-05 23:12:40","ftime":"2025-03-05 23:12:40","context":"【汕头市】 快件已发往 揭阳转运中心"},{"time":"2025-03-05 22:24:48","ftime":"2025-03-05 22:24:48","context":"【汕头市】 汕头东海岸（0754-83915110）柯晓敏（16626115837） 已揽收"}]}';
      // this.logisticsList = JSON.parse(result) ? JSON.parse(result).data : [];
      logisticsListApi({
        orderId: this.orderId,
      }).then((res) => {
        if (res.resultStatus) {
          const result = res.resultData.result;
          this.logisticsList = res.resultData.result
            ? JSON.parse(result)
              ? JSON.parse(result).data
              : []
            : [];
        } else {
          this.$message.warning(res.errorMessage);
          this.logisticsList = []
        }
      })
      .catch((error)=>{
        this.logisticsList = []
        console.log(error)
      })
    },
  },
};
</script>

<style lang="less">
.order_detail_page {
  padding: 20px;
  .time_line_box {
    border-bottom: 2px dashed #e1e1e1;
    display: flex;
    .time_line_item {
      width: 140px;
      height: 90px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .line_box {
        background: #eee;
        width: 100%;
        height: 4px;
        border-radius: 6px;
        position: relative;
        .line_pointer {
          background: #eee;
          width: 12px;
          height: 12px;
          border-radius: 100%;
          position: absolute;
          top: -4px;
          left: 44%;
        }
      }

      .active {
        background: #00a0e9;
        .line_pointer {
          background: #00a0e9;
        }
      }
      .name {
        font-size: 13px;
        color: #999;
        margin-top: 10px;
      }
      .active_name {
        color: #00a0e9;
      }
      .time {
        width: 100%;
        height: 30px;
        font-size: 13px;
        color: #00a0e9;
        display: inline-flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
  .order_detail_content {
    .el-form-item {
      margin-bottom: 2px;
    }
  }
  .download {
    font-size: 13px;
    color: #00a0e9;
    cursor: pointer;
    text-decoration: underline;
  }
}
.flex_wrap {
  display: flex;
  flex-wrap: wrap;
}
</style>